<template>
  <Icon :component="AvatarSvg" />
</template>

<script lang="ts">
import { defineComponent, markRaw } from 'vue';
import Icon from '@ant-design/icons-vue';
import AvatarSvg from './svg/AvatarSvg.vue';

export default defineComponent({
  name: 'AvatarIcon',
  components: {
    Icon
  },
  props: {},
  data() {
    return {
      AvatarSvg: markRaw(AvatarSvg)
    };
  }
});
</script>
